<template>
  <div class="mobile-desktop-only-screen">
    <div class="mobile-desktop-only-card">
      <img
        :src="LogoPath"
        alt="Logo"
        class="mobile-desktop-only-logo"
      />
      <div class="mobile-desktop-only-icon">
        <i class="pi pi-desktop" aria-hidden="true" />
      </div>
      <h1 class="mobile-desktop-only-title">
        {{ appTitle }}
      </h1>
      <p class="mobile-desktop-only-message">
        Для продолжения работы откройте приложение на компьютере
      </p>
      <p class="mobile-desktop-only-hint">
        Эта версия предназначена для десктопного браузера
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import LogoPath from '@/common/constants/logo'
import { configService } from '@/common/utils/clientConfig'

const appTitle = configService.get('TITLE')
</script>

<style scoped>
.mobile-desktop-only-screen {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 100%);
}

.mobile-desktop-only-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 420px);
  padding: 2.5rem 2rem;
  text-align: center;
  background: #ffffff;
  border: 1px solid rgba(30, 58, 110, 0.08);
  border-radius: 16px;
  box-shadow:
    0 20px 45px rgba(15, 23, 42, 0.08),
    0 2px 8px rgba(15, 23, 42, 0.04);
  animation: mobileDesktopOnlyFadeIn 0.45s ease;
}

.mobile-desktop-only-logo {
  display: block;
  width: 96px;
  height: 96px;
  margin: 0 0 1.5rem;
  object-fit: contain;
}

.mobile-desktop-only-icon {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  margin: 0 0 1rem;
  border-radius: 999px;
  background: color-mix(in srgb, var(--p-primary-color, #1e3a6e) 12%, white);
  color: var(--p-primary-color, #1e3a6e);
  font-size: 1.5rem;
}

.mobile-desktop-only-title {
  width: 100%;
  margin: 0 0 1rem;
  color: #0f172a;
  font-size: 1.375rem;
  font-weight: 600;
  line-height: 1.3;
}

.mobile-desktop-only-message {
  width: 100%;
  margin: 0 0 0.75rem;
  color: #334155;
  font-size: 1rem;
  line-height: 1.5;
}

.mobile-desktop-only-hint {
  width: 100%;
  margin: 0;
  color: #64748b;
  font-size: 0.875rem;
  line-height: 1.5;
}

@keyframes mobileDesktopOnlyFadeIn {
  from {
    opacity: 0;
    transform: translateY(16px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
